'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cacheCart = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

require('whatwg-fetch');

require('es6-promise/auto');

var _themeCart = require('./themeCart/theme-cart');

var _handlers = require('./handlers');

var _Flow = require('../components/Flow');

var _Flow2 = _interopRequireDefault(_Flow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCart = function getCart() {
  return $.getJSON('/cart.json', function (cart) {
    return cart;
  });
};

var cacheCart = exports.cacheCart = function cacheCart() {
  (0, _themeCart.getState)().then(function (cart) {
    return window.prg.cart = cart;
  });
};

var replaceCartState = function replaceCartState(newCart) {
  (0, _handlers.clearState)('cart');
  (0, _handlers.setState)(Object.assign({ container: 'cart', change: 'update' }, newCart));
};

var updateCartState = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(data) {
    var requestData, responseData, action, method;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // console.log('==== update cart data (should match addItem data)', data);

            requestData = data.requestData, responseData = data.responseData;
            action = requestData.action, method = requestData.method;

            if (!(action === 'add' || method === 'addItem')) {
              _context.next = 7;
              break;
            }

            _context.next = 5;
            return getCart().then(function (cart) {
              // console.log('==== updateCartState getcartstate', cart);
              return replaceCartState(cart);
            }).catch(function (error) {
              console.log('==== update cart err', error);
            });

          case 5:
            _context.next = 8;
            break;

          case 7:
            if (action === 'remove' || method === 'removeItem' || action === 'update' || method === 'updateItem') {
              replaceCartState(responseData);
            }

          case 8:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function updateCartState(_x) {
    return _ref.apply(this, arguments);
  };
}();

var enqueueRequest = function enqueueRequest(request) {
  var currentRequests = (0, _handlers.getState)('request');
  var data = [].concat((0, _toConsumableArray3.default)(currentRequests), (0, _toConsumableArray3.default)(request));

  data.container = 'request';
  data.change = 'enqueue';

  (0, _handlers.setState)(data);
};

var dequeueRequest = function dequeueRequest(request) {
  var _ref2 = request.requestData || {},
      _ts = _ref2._ts;

  var requests = (0, _handlers.getState)('request');
  var data = requests.filter(function (request) {
    return request._ts !== _ts;
  });

  data.container = 'request';
  data.change = 'dequeue';

  (0, _handlers.setState)(data);
};

exports.default = {
  updateState: updateCartState,
  enqueueRequest: enqueueRequest,
  dequeueRequest: dequeueRequest
};